import React from "react";
import user from "../../../assets/icons/user.png";

export default function UserProfileImageList({ index, text, totalPatients }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginRight: "-5px",
        width: 24,
        height: 24,
        borderRadius: 100,
        backgroundColor: index === 5 ? "#6B43B5" : index % 2 === 1 ? "#C9C1F1" : "#E0DDF7",
        border: "1px solid #ffffff",
      }}
    >
      {index === 0 ? (
        <img src={user} alt="user-icon" style={{ color: "white" }} />
      ) : (
        <span style={{ color: "#ffffff", textTransform: "capitalize", fontSize: 12 }}>{index > 4 ? `+${totalPatients - 5}` : text}</span>
      )}
    </div>
  );
}
